import readXlsxFile from "read-excel-file";

function parseCsvText(text) {
  const lines = String(text || "")
    .replace(/^\uFEFF/, "")
    .split(/\r?\n/)
    .filter((line) => line.trim());
  if (!lines.length) return [];
  const headers = splitCsvLine(lines[0]).map((h) => h.trim());
  return lines.slice(1).map((line) => {
    const cells = splitCsvLine(line);
    const item = {};
    headers.forEach((header, i) => {
      if (header) item[header] = cells[i] ?? "";
    });
    return item;
  }).filter((item) => Object.values(item).some((v) => String(v || "").trim()));
}

function splitCsvLine(line) {
  const out = [];
  let current = "";
  let inQuotes = false;
  for (let i = 0; i < line.length; i += 1) {
    const ch = line[i];
    if (ch === '"') {
      if (inQuotes && line[i + 1] === '"') {
        current += '"';
        i += 1;
      } else {
        inQuotes = !inQuotes;
      }
    } else if (ch === "," && !inQuotes) {
      out.push(current);
      current = "";
    } else {
      current += ch;
    }
  }
  out.push(current);
  return out;
}

/**
 * Parse CSV or Excel upload to row objects (column headers from first row).
 */
export async function parseSpreadsheetFile(file) {
  const name = String(file?.name || "").toLowerCase();
  if (name.endsWith(".csv")) {
    const text = await file.text();
    const parsed = parseCsvText(text);
    if (parsed.length) return parsed;
  }
  const rows = await readXlsxFile(file);
  if (!rows?.length) return [];
  const headers = rows[0].map((h) => String(h ?? "").trim());
  return rows
    .slice(1)
    .filter((row) => row?.some((cell) => cell != null && String(cell).trim() !== ""))
    .map((row) => {
      const item = {};
      headers.forEach((header, i) => {
        if (header) item[header] = row[i];
      });
      return item;
    });
}

